import React from 'react'
import Link from 'next/link'

interface SecondaryButtonProps {
  children: React.ReactNode
  onClick?: () => void
  href?: string
  className?: string
  type?: 'button' | 'submit' | 'reset'
  fullWidth?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'px-4 py-2.5 text-sm',
  md: 'px-5 py-3 text-[15px]',
  lg: 'px-6 py-3.5 text-[15px]'
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  children,
  onClick,
  href,
  className = '',
  type = 'button',
  fullWidth = false,
  size = 'md'
}) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-xl border border-border-subtle bg-white/[0.03] font-semibold text-primary transition-all duration-200 hover:border-link-blue/40 hover:bg-white/[0.06]'
  const sizeClass = sizeClasses[size]
  const widthClass = fullWidth ? 'w-full' : ''
  const combinedClasses = `${baseClasses} ${sizeClass} ${widthClass} ${className}`.trim()
  const isInternalHref =
    !!href && (href.startsWith('/') || href.startsWith('#'))

  if (href) {
    if (!isInternalHref) {
      return (
        <a
          href={href}
          className={combinedClasses}
        >
          {children}
        </a>
      )
    }

    return (
      <Link
        href={href}
        className={combinedClasses}
      >
        {children}
      </Link>
    )
  }

  return (
    <button
      type={type}
      onClick={onClick}
      className={combinedClasses}
    >
      {children}
    </button>
  )
}

export default SecondaryButton
